import { Grid } from '@mui/material';
import AcademicsMaterialsGrid from './academicsMaterialsGrid.view';
import { useAcademicsMaterialsState } from '../../contexts/academicsMaterials.context';
import AddEditMaterialsView from './addEditMaterials.view';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import {
  IAcademicsMaterials,
  MaterialCategory,
  MaterialCondition,
  MaterialStatus,
} from 'src/apis/academics/academicsMaterials.interfaces';
import { z } from 'zod';
import { zNumberFromInput } from 'src/utils/zodFormHelpers';
import AddEditEachmaterialView from './addEditEachmaterial.view';

const academicsMaterialsFormSchema = z.object({
  materials: z.array(
    z.object({
      name: z.string().min(1),
      description: z.string().min(1),
      quantity: zNumberFromInput({ min: 1 }),
    })
  ),
});

const defaultValues: IAcademicsMaterials = {
  id: '',
  documents: {
    receipts: [],
    invoices: [],
    payments: [],
  },
  category: MaterialCategory.OTHER,
  status: MaterialStatus.AVAILABLE,
  condition: MaterialCondition.NEW,
  purchaseDate: new Date(),
  lastMaintenanceDate: new Date(),
  location: '',
  quantity: 0,
  minimumQuantity: 0,
  cost: 0,
  tags: [],
  actions: {
    created: {
      userId: '',
      timestamp: new Date().getTime(),
    },
  },
  materials: [],
  totalCount: 0,
  availableCount: 0,
  inUseCount: 0,
  maintenanceCount: 0,
  retiredCount: 0,
  totalValue: 0,
  lastInventoryDate: new Date(),
  department: '',
  notes: '',
  name: '',
  description: '',
};

const AcademicsMaterialsView = () => {
  const {
    academicsMaterialsAppState: {
      isManageMaterialOpen,
      isManageEachMaterialOpen,
    },
  } = useAcademicsMaterialsState();
  const methods = useForm<IAcademicsMaterials>({
    resolver: zodResolver(academicsMaterialsFormSchema),
    mode: 'onBlur',
    defaultValues,
  });
  return (
    <FormProvider {...methods}>
      <Grid
        container
        spacing={{ xs: 1, sm: 2 }}
        sx={{ p: { xs: 1, sm: 2 } }}
        data-testid="academics-materials-container"
      >
        <Grid item xs={12}>
          <AcademicsMaterialsGrid />
        </Grid>
        {isManageMaterialOpen && <AddEditMaterialsView />}
        {isManageEachMaterialOpen && <AddEditEachmaterialView />}
      </Grid>
    </FormProvider>
  );
};

export default AcademicsMaterialsView;
